export default defineAppConfig({
  site: {
    orgName: 'Bible school',
    defaultCountryIso: 'am',
    geoDetect: false,
    showRegionField: false,
    showExpertsSection: false,
    phone: '+375 33 677 16 77',
    phoneTel: '+375336771677',
    email: null as string | null,
    supportUrl: null as string | null,
  },
})
